import Header from "./Header";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Menu from "./Menu";
import SelectProject from "../../pages/dashboard/SelectProject";
import AgentChatbot from "../const/AgentChat";

function Layout({ children }) {
  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.id) {
      setUsername(user.name);
    } else {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <>
      <Header />
      {/* <Menu /> */}
      <main style={{}}>
        <Outlet />
        {/* Q&A Button */}
        {/* <button
          onClick={() => {
            const parts = window.location.pathname.split('/');
            const pIndex = parts.indexOf('project');
            if (pIndex !== -1 && parts[pIndex + 1]) {
              navigate(`/project/${parts[pIndex + 1]}/system/faq`);
            }
          }}
          className="fixed bottom-6 right-36 bg-white text-gray-800 px-5 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 z-[9999] border border-gray-200 font-bold"
        >
          Q & A
        </button> */}
        <AgentChatbot />
      </main>
    </>
  );
}

export default Layout;
